/* eslint-disable */

import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Swal from "sweetalert2";
import apiInstance from "../../../../utils/api";
import DialogTitle from "@mui/material/DialogTitle";
import { useState, useEffect } from "react";
export default function ReagentDialog(props) {
  console.log(props, "props");
  const [category, setCategory] = useState("");
  const [categoryLists, setCategoryLists] = useState([]);

  const [code, setCode] = useState("");
  const [name, setName] = useState("");

  const [description, setDescription] = useState("");

  const ReagentCreate = () => {
    const data = {
      name: name,
      code: code,
      // relatedCategory: category,
      // relatedSubCategory: subCategory,

      // relatedBrand: relatedBrand,
      description: description,
    };

    if (category) data.relatedCategory = category;

    // alert(JSON.stringify(data))
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    apiInstance.post("reagent-list", data, config).then(function (response) {
      Swal.fire({
        title: "Successful!",
        text: "You Created Data!",
        icon: "success",
        // showCancelButton: true,
        showConfirmButton: false,
        timer: 2000,
      });

      props.setReagent([...props.reagent, response.data.data]);
    });

    props.setOpen(false);
  };

  useEffect(() => {
    const getCategory = async () => {
      try {
        const res = await apiInstance.get("reagent-category");

        setCategoryLists(res.data.data);
      } catch (err) { }
    };

    getCategory();
  }, []);

  return (
    <div>
      <Dialog open={props.open} onClose={props.close} fullWidth maxWidth='md'>
        <DialogTitle>
          <div className='modal-header' style={{ backgroundColor: '#0b9490', color: 'white', borderRadius: '7px' }}>
            <h4 className='modal-title'>Create New Item</h4>
            <button
              type='button'
              className='close'
              data-dismiss='modal'
              aria-label='Close'
              onClick={props.close}
            >
              <span aria-hidden='true'>&times;</span>
            </button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>

          {/* @csrf */}
          <div class='modal-body'>
            <div class='form-group'>
              <label for='code'>Code</label>
              <input
                type='text'
                class='form-control border border-info'
                name='code'
                onChange={e => setCode(e.target.value)}
              />
            </div>
            <div class='form-group'>
              <label for='name'>Name</label>
              <input
                type='text'
                class='form-control border border-info'
                name='name'
                placeholder='eg. mg mg'
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div class='form-group'>
              <label for='name'>Category</label>
              <select
                class='custom-select border-info'
                name='account_type_id'
                id='cat'
                onChange={e => setCategory(e.target.value)}
              >
                <option hidden>Choose Category</option>
                {categoryLists.map(option => (
                  <option value={option._id}>{option.name}</option>
                ))}
              </select>
            </div>

            <div class='form-group'>
              <label for='name'>Description</label>
              <textarea
                className='form-control'
                id='description'
                onChange={e => setDescription(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div class='modal-footer'>
            <Button
              class='btn btn-secondary'
              data-dismiss='modal'
              onClick={props.close}
            >
              Close
            </Button>
            <Button class='btn' style={{ backgroundColor: '#0b9490', color: 'white' }} onClick={ReagentCreate}>
              Save
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
// phyo
//maymyat
